/**
 * Check if any typography values are set for any breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type { ResponsiveBreakpoint, TypographyAttributes } from '../../types';

/**
 * Check if any typography values are set for any breakpoint
 */
export const hasAnyTypographyValues = (
	attributes: TypographyAttributes,
): boolean => {
	if ( ! attributes ) {
		return false;
	}

	return [ 'desktop', 'tablet', 'mobile' ].some( ( breakpoint ) => {
		const values = attributes[ breakpoint as ResponsiveBreakpoint ];
		return (
			values &&
			Object.values( values ).some( ( value ) => value && value !== '' )
		);
	} );
};
